import { AfterViewInit, Injectable, OnDestroy } from '@angular/core';
import { Standard } from './models/standard.model';
import { StandardScale } from './models/standard-scale.model';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { StandardScaleValue } from './models/standard-scale-value.model';

@AutoUnsubscribe()
@Injectable({
    providedIn: 'root'
})
export class GradebookV10StandardsService implements AfterViewInit, OnDestroy {

    StandardsHierarchy: Standard[];
    assignedStandards: Standard[];
    editedAssignmentId: number;

    constructor() { }

    ngAfterViewInit() {
    }

    getStandardHierarchy(standards: Standard[]): Standard[] {
        let standardTrees = [];
        var parentStandards = standards.filter(standard => standard.Parent_ID == -1);
        for (var i = 0; i < parentStandards.length; i++) {
            let parentStandard = parentStandards[i];
            let standardTree = [{ Id: parentStandard.Id, StandardName: parentStandard.StandardName, Level: parentStandard.Level, Standards: [] }];
            for (let j = 0; j < standards.length; j++) {
                var standard = standards[j];
                if (standard.Parent_ID == -1)
                    continue;
                standard.Standards = [];
                var parentId = standard.Parent_ID;
                var parent = this.getStandardParent(standardTree[0], parentId)
                if (parent != null)
                    parent.Standards.push({ Id: standard.Id, StandardName: standard.StandardName, Level: standard.Level, Standards: [] });
            }
            standardTrees.push(standardTree);
        }

        let standardsHierarchy = [];
        for (let i = 0; i < standardTrees.length; i++) {
            let standardTree = standardTrees[i];
            let rootStandard = standards.filter(standard => standard.Id == standardTree[0].Id)[0];
            standardsHierarchy.push(rootStandard);
            for (let j = 0; j < standardTree[0].Standards.length; j++) {
                let tempStandard = standardTree[0].Standards[j];
                let standard = standards.filter(standard => standard.Id == tempStandard.Id)[0];
                if (standardsHierarchy.filter(hierarchyStandard => hierarchyStandard.Id == standard.Id)[0] == undefined)
                    standardsHierarchy.push(standard);
                var childStandards = this.getStandardChildren(tempStandard);
                if (childStandards != null) {
                    for (var k = 0; k < childStandards.length; k++) {
                        var childStandard = standards.filter(child => child.Id == childStandards[k].Id)[0];
                        if (standardsHierarchy.filter(hierarchyStandard => hierarchyStandard.Id == childStandards[k].Id)[0] == undefined)
                            standardsHierarchy.push(childStandard);
                    }
                }
            }
        }
        if (!this.StandardsHierarchy)
            this.StandardsHierarchy = standardsHierarchy;
        return standardsHierarchy;

    }

    getStandardParent(root, parentId: number) {
        if (parentId == root.Id)
            return root;

        for (var i = 0; i < root.Standards.length; i++) {
            var child = root.Standards[i];
            if (child.Id == parentId)
                return child;
            if (child.Standards.length > 0)
                var childResult = this.getStandardParent(child, parentId);
            if (childResult != null)
                return childResult;
        }
        return null;
    }

    getStandardChildren(standard): Standard[] {
        var standards = []
        standards.push(standard);
        if (standard.Standards.length == 0)
            return standards;
        for (var i = 0; i < standard.Standards.length; i++) {
            if (standard.Standards.length > 0)
                var childResults = this.getStandardChildren(standard.Standards[i]);
            if (childResults != null && childResults.length > 0)
                standards = standards.concat(childResults);
        }
        return standards;
    }

    setStandardParents(standard, isAssigned) {
        if (standard.Parent_ID == -1) {
            this.assignedStandards.unshift(standard);
            return;
        }
        else {
            if (!isAssigned)
                this.assignedStandards.unshift(standard);
            this.setStandardParents(this.StandardsHierarchy.filter(function (element) { return element.Id == standard.Parent_ID })[0], false);
        }
    }


    getAssignmentStandardHierarchy(standards: Standard[], allStandards: Standard[]): Standard[] {
        let attachedStandards = JSON.parse(JSON.stringify(standards));
        let assignmentStandardHierarchy: Standard[] = [];
        this.StandardsHierarchy = allStandards;
        for (var i = 0; i < standards.length; i++) {
            this.assignedStandards = [];
            var assignedStandard = this.StandardsHierarchy.filter(function (element) { return element.Id == standards[i].Id })[0];
            this.setStandardParents(assignedStandard, true);
            assignedStandard.parents = this.assignedStandards;
        }
        var assignmentStandards = standards;
        standards = [];
        for (var i = 0; i < assignmentStandards.length; i++) {
            var standard = this.StandardsHierarchy.filter(function (element) { return element.Id == assignmentStandards[i].Id })[0];
            for (var j = 0; j < standard.parents.length; j++)
                standards.push(standard.parents[j]);
            standards.push(standard);
        }
        // Remove Duplicates
        for (let standard of this.StandardsHierarchy) {
            standard.parents = undefined;
            if (standards.filter(filteredStandard => filteredStandard.Id == standard.Id).length > 0) {
                let attachedStandard = attachedStandards.filter(filteredStandard => filteredStandard.Id == standard.Id)[0];
                standard.isAttached = (attachedStandard != undefined) ? true : false;
                assignmentStandardHierarchy.push(standard);
            }
        }
        return assignmentStandardHierarchy;
    }

    checkInvalidStandardScore(score: any, standardScales: StandardScale[]): boolean {
        if (!this.StandardsHierarchy)
            return false;
        let standard = this.StandardsHierarchy.filter(s => s.Id == score.Standard_ID)[0];
        let scale = standardScales.filter(scale => scale.Id == standard.BenchMarkScale)[0];
        if (scale != undefined) {
            let value: StandardScaleValue;
            value = scale.Values.filter(value => value.Value.toString().toLowerCase() == score.Score.toLowerCase())[0];
            let isValid: boolean = false;
            if (score.Score == '')
                isValid = true;
            else if (scale.SingleGradeScale && value != undefined) {
                score.Score = value.Value;
                isValid = true;
            }
            else if (!scale.SingleGradeScale && !isNaN(Number(score.Score)) && parseFloat(score.Score) >= scale.MinPoints && parseFloat(score.Score) <= scale.MaxPoints) {
                isValid = true;
            }
            score.Invalid = !isValid;
            return !isValid;
        }
        else {
            return (score.Score == '') ? false : true;
        }
    }

    ngOnDestroy() {
    }
}